import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  Typography,
  TextField,
  CircularProgress,
} from "@mui/material";
import styles from "./ticketCommentsDialogStyles";

TicketCommentsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default function TicketCommentsDialog({ onClose, open, onConfirm }) {
  const [commentary, setCommentary] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCommentaryChange = (event) => {
    setCommentary(event.target.value);
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setCommentary("");
    onClose();
  };

  const handleConfirm = async () => {
    if (!commentary.trim()) {
      return;
    }
    setIsLoading(true);
    await onConfirm(commentary);
    setIsLoading(false);
    setCommentary("");
    onClose();
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          Finalizar Ticket
        </Typography>
        <Typography component="div" variant="body1" style={styles.subtitle}>
          Ingresa los comentarios sobre la resolución del ticket
        </Typography>

        <Container sx={styles.divider}></Container>

        <TextField
          id="standard-basic"
          label="Comentarios *"
          variant="outlined"
          onChange={handleCommentaryChange}
          value={commentary}
          type="text"
          multiline
          rows={4}
          inputProps={{ maxLength: 100 }}
          sx={styles.textField}
          error={commentary.trim() === "" && commentary !== ""}
          helperText={
            commentary.trim() === "" && commentary !== ""
              ? "Los comentarios son obligatorios"
              : `${commentary.length}/100`
          }
        />

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={styles.cancelButton}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={!commentary.trim() || isLoading}
            sx={
              commentary.trim() && !isLoading
                ? styles.activeButton
                : styles.inactiveButton
            }
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              "Confirmar"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}

